import { render, staticRenderFns } from "./relevanceDialog.vue?vue&type=template&id=601df7cd&"
import script from "./relevanceDialog.vue?vue&type=script&lang=js&"
export * from "./relevanceDialog.vue?vue&type=script&lang=js&"
import style0 from "./relevanceDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports